<template>
  <Header></Header>
  <div><el-image :src="sf_dt"></el-image></div>
  <!-- 梳化床 -->
  <div>
    <div class="title">梳化床系列</div>
    <div class="subtitle">可定制規格尺寸</div>
    <div class="sfcmk clearfix">
      <div class="sfc" v-for="item of sfc" :key="item.index">
        <el-image class="sfc-tp" :src="item.url"></el-image>
        <div class="sfc-wz">{{ item.des }}</div>
      </div>
    </div>
  </div>

  <!-- 梳化 -->
  <div>
    <div class="title">梳化系列</div>
    <div class="subtitle">可定制規格尺寸</div>
    <div class="yzmk clearfix">
      <div class="yz" v-for="item of sfd" :key="item.index">
        <el-image class="yz-tp" :src="item.url"></el-image>
        <div class="sfc-wz">{{ item.des }}</div>
      </div>
    </div>
  </div>

  <!-- 椅子 -->
  <div>
    <div class="title">椅子系列</div>
    <div class="subtitle">可定制規格尺寸</div>
    <div class="yzmk clearfix">
      <div class="yz" v-for="item of yz" :key="item.index">
        <el-image class="yz-tp" :src="item.url"></el-image>
        <div class="sfc-wz">{{ item.des }}</div>
      </div>
    </div>
  </div>
  <!-- 腳凳 -->
  <div>
    <div class="title">腳踏系列</div>
    <div class="subtitle">可定制規格尺寸</div>
    <div class="yzmk clearfix">
      <div class="yz" v-for="item of jd" :key="item.index">
        <el-image class="yz-tp" :src="item.url"></el-image>
        <div class="sfc-wz">{{ item.des }}</div>
      </div>
    </div>
  </div>
  <Footer></Footer>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  name: "Sf",
  data() {
    return {
      company_sn:"R",
      sf_dt: "http://139.159.153.112:8200/gw_lmm/sf1.jpg",
      sfc:[],
      yz:[],
      jd:[],
      sfd:[]
      // sfc: [
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfc/1.jpg",
      //     des: "TD04款 J25布",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfc/2.jpg",
      //     des: "TD02款 WX104-1布",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfc/3.jpg",
      //     des: "TD04款 WX104-2布",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfc/4.jpg",
      //     des: "SRK02款 WX102-10布",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfc/5.jpg",
      //     des: "A款 WX102-2布",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfc/6.jpg",
      //     des: "C101款梳化床",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfc/7.jpg",
      //     des: "TD03款梳化床",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfc/8.jpg",
      //     des: "H款梳化床",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfc/9.jpg",
      //     des: "B款梳化床",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfc/10.jpg",
      //     des: "SRK07",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfc/11.jpg",
      //     des: "PA款",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfc/12.jpg",
      //     des: "P313款",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfc/13.jpg",
      //     des: "P312款",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfc/14.jpg",
      //     des: "P311款",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfc/15.jpg",
      //     des: "P309款",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfc/16.jpg",
      //     des: "P308款",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfc/17.jpg",
      //     des: "P305款",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfc/18.jpg",
      //     des: "P304款",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfc/19.jpg",
      //     des: "P303款",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfc/20.jpg",
      //     des: "P302款",
      //   },
      // ],
      // yz: [
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/yz/1.jpg",
      //     des: "鑽石鈕長背椅",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/yz/2.jpg",
      //     des: "長背椅 J26布",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/yz/3.jpg",
      //     des: "單扶手公主椅 J27布",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/yz/4.jpg",
      //     des: "皇子椅 仿皮",
      //   },
      // ],
      // sfd: [
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfd/1.jpg",
      //     des: "V款 電動鉸梳化",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfd/2.jpg",
      //     des: "QA款儲物揭蓋梳化",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfd/3.jpg",
      //     des: "2010-I 款",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfd/4.jpg",
      //     des: "Q款-53HL",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/sfd/5.jpg",
      //     des: "P款",
      //   },
      // ],
      // jd: [
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/jd/1.jpg",
      //     des: "圓型鑽石鈕腳踏",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/jd/2.jpg",
      //     des: "方形儲物箱 仿皮 / J25布",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/jd/3.jpg",
      //     des: "長方形軟皮儲物箱 鑽石鈕",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/jd/4.jpg",
      //     des: "長方形腳踏 WX104-1布",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/jd/5.jpg",
      //     des: "腰果形腳踏 WX102-10布",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/jd/6.jpg",
      //     des: "三角型腳踏 J27布紋",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/jd/7.jpg",
      //     des: "腰果型腳踏 J21布紋",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/jd/8.jpg",
      //     des: "腰果型腳踏 米A皮",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/jd/9.jpg",
      //     des: "蛋型腳踏 J25布紋",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/jd/10.jpg",
      //     des: "圓型腳踏 J20布紋",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/jd/11.jpg",
      //     des: "通心腳踏 啡皮",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/jd/12.jpg",
      //     des: "通心腳踏 J20布紋",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/jd/13.jpg",
      //     des: "長方型腳踏 J26布紋",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/sf/jd/14.jpg",
      //     des: "四方型腳踏 J22布紋",
      //   },
      // ],
    };
  },
  components: { Header, Footer },
    created(){
      console.log(123)
    if(sessionStorage.getItem("company_sn")!=null){
      this.company_sn=sessionStorage.getItem("company_sn")
      this.queryProdSFC()
      this.queryProdYZ()
      this.queryProdSFD()
    }
  },
  methods:{
    // 查询推荐货品
    queryProdSFC() {
      this.$api.queryprod({company_sn:this.company_sn,category_sn:"C001",high:0}).then(
        res => {
          if (res.state == 10000) {
            this.sfc=res.data.prod
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    },
    // 查询推荐货品
    queryProdSFD() {
      this.$api.queryprod({company_sn:this.company_sn,category_sn:"C002",high:0}).then(
        res => {
          if (res.state == 10000) {
            this.sfd=res.data.prod
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    },
      // 查询推荐货品
    queryProdYZ() {
      this.$api.queryprod({company_sn:this.company_sn,category_sn:"C003",high:0}).then(
        res => {
          if (res.state == 10000) {
            console.log(res)
            this.yz=res.data.prod
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    },
  }
};
</script>

<style scoped>
.title {
  margin-top: 60px;
  font-size: 40px;
  color: rgb(51, 51, 51);
}
.subtitle {
  font-size: 16px;
  line-height: 72px;
  color: rgb(51, 51, 51);
}
/* 沙發床 */
.sfcmk {
  width: 1260px;
  margin: 0 auto;
}
.sfc {
  float: left;
  width: 380px;
  height: 380px;
  margin: 20px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
}
.sfc-tp {
  width: 380px;
  height: 300px;
}

/* 椅子 */
.yzmk {
  width: 1260px;
  margin: 0 auto;
}
.yz {
  float: left;
  width: 275px;
  height: 275px;
  margin: 20px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
}
</style>